import React, { useEffect, useState } from "react";
import "./index.scss";
import { process } from "./mockdata";
import { Carousel } from "../Carousel/Carousel";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { getMediaDevice, omitNation } from "../../helpers/utils";
import { getTopRankedPlayers } from "../../services/rankings";
import { Sponsors } from "./sponsors";

interface PlayerType {
  playerNationalityCode: string;
  name: string;
  rankMovement: string;
  type: string;
  playerGivenName: string;
  playerFamilyName: string;
  ProfileLink: string;
  PlayerId: string;
  RankingsLink: string;
  AgeCategoryDescription?: string;
}

const showTour = (tourCode: string) => {
  switch (tourCode) {
    case "MT":
      return "World";
    case "WT":
      return "World";
    case "JT":
      return "World";
    case "VT":
      return "World Tennis Masters";
    case "WCT":
      return "Wheelchair";
    case "BT":
      return "Beach";
    default:
      return;
  }
};

const itemsToDisplay = { DESKTOPXL: 2, DESKTOP: 2, TABLET: 2, MOBILE: 1 };

const Player = ({ player, circuit }: any) => {
  return (
    <div
      className={`rankings-home__circuit-item ${player.tourCode} ${player.PlayerType} ${player.PlayerId}`}
    >
      <div className="rankings-home__circuit-item-name">{`${`${showTour(
        player.tourCode
      )}`}${player.tourCode !== "VT" ? " Tennis" : ""} ${
        player.tourCode === "WCT" &&
        (player.PlayerType === "Boys" || player.PlayerType === "Girls")
          ? "Junior "
          : ""
      }${player.tourCode === "BT" ? "World " : ""}Tour${
        player.tourCode === "JT" ? " Juniors" : ""
      }`}</div>
      <div className="rankings-home__circuit-item-info">
        <div
          className="rankings-home__circuit-item-image"
          style={{
            backgroundImage: `url("${circuit.host}${
              player.ProfilePictureUrls.filter(
                (image: any) => image.cropKey === "Small"
              )[0].imageUrl
            }")`
          }}
        ></div>
        <div className="rankings-home__circuit-item-detail">
          <a className="name" href={player.ProfileLink}>
            <p className="name-first">{player.PlayerGivenName}</p>
            <p className="name-last">{player.PlayerFamilyName}</p>
          </a>
          <div className="country">
            <div
              className={`itf-flags itf-flags--${player.PlayerNationalityCode}`}
            ></div>
            <div>{omitNation(player.PlayerNationalityCode)}</div>
          </div>
          <p className="ranking">
            <span
              className={`rankings-home__rank-${
                parseInt(player.RankMovement) >= 1
                  ? "positive"
                  : parseInt(player.RankMovement) < 0
                  ? "negative"
                  : "neutral"
              }`}
            >
              {player.RankMovement == "0" ? "-" : player.RankMovement}
            </span>
          </p>
        </div>
      </div>
      <a
        href={player.RankingsLink}
        className="rankings-home__circuit-item-link"
      >
        <span>
          {`${
            player.tourCode === "WCT" &&
            (player.PlayerType === "Boys" || player.PlayerType === "Girls")
              ? `${Sponsors.JT} `
              : ""
          }`}
          {`${
            player.tourCode === "JT" ||
            (player.tourCode === "WCT" &&
              (player.PlayerType === "Boys" || player.PlayerType === "Girls"))
              ? "Junior "
              : ""
          }
          ${
            player.PlayerType === "Boys"
              ? "Boys'"
              : player.PlayerType === "Girls"
              ? "Girls'"
              : player.PlayerType
          }${
            player.PlayerType == "Men" || player.PlayerType == "Women"
              ? "'s "
              : " "
          }${
            player.tourCode === "VT"
              ? " " + player.AgeCategoryDescription.split(" ").pop() + "+"
              : ""
          }`}{" "}
          Rankings
        </span>
        <div className="rankings-home__link" />
      </a>
    </div>
  );
};

const Circuit = ({ circuit }: any) => {
  return (
    <div className="rankings-home__circuit">
      {circuit.items.map((player: PlayerType) => (
        <Player key={player.PlayerId} player={player} circuit={circuit} />
      ))}
    </div>
  );
};

const Slides = ({ page, itemsToDisplay, circuit }: any) => {
  return (
    <ReactCSSTransitionGroup
      transitionName="carousel__animation"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
      className={`carousel__animation-container`}
    >
      <div className="rankings-home__circuit">
        {circuit.items
          .slice(
            page * itemsToDisplay[getMediaDevice()],
            (page + 1) * itemsToDisplay[getMediaDevice()]
          )
          .map((player: PlayerType) => {
            return (
              <Player key={player.PlayerId} player={player} circuit={circuit} />
            );
          })}
      </div>
    </ReactCSSTransitionGroup>
  );
};

interface Circuit {
  tour: string;
  items: Player[];
}

interface Player {
  PlayerFamilyName: string;
  PlayerGivenName: string;
  RankMovement: string;
  tourCode: string;
  MatchType: string;
  PlayerType: string;
}

const RankingsHome = ({ circuits }: { circuits: string }) => {
  const [Rankings, updateRankings] = useState<Circuit[]>([]);
  useEffect(() => {
    getTopRankedPlayers({ circuits }).then(({ res, host }) => {
      updateRankings(process(res, host));
    });
  }, []);
  return (
    <section className="rankings-home page-section page-section--no-bg">
      <div className="container">
        <h1>Rankings: Top-ranked players</h1>

        <div
          className={`rankings-home__wrapper carousel${
            !Rankings.length ? " isLoading" : ""
          }`}
        >
          {!Rankings.length
            ? ""
            : Rankings.map(circuit => (
                <Carousel
                  key={circuit.tour}
                  totalItems={circuit.items.length}
                  itemsToDisplay={itemsToDisplay}
                  pagerPerItem
                >
                  <Slides
                    page={0}
                    circuit={circuit}
                    itemsToDisplay={itemsToDisplay}
                  />
                </Carousel>
              ))}
        </div>
        <div
          className={`rankings-home__wrapper non-carousel${
            !Rankings.length ? " isLoading" : ""
          }`}
        >
          {Rankings.map(circuit => (
            <Circuit key={circuit.tour} circuit={circuit} />
          ))}
        </div>
      </div>
    </section>
  );
};
export default RankingsHome;
